module.exports = __webpack_public_path__ + "img/instagram-button.b053b556.svg";